module.exports = __webpack_public_path__ + "7f690e503a254e0b8349aec0177e07aa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Lato-Regular.ttf
// module id = 309
// module chunks = 0